// extracted by mini-css-extract-plugin
export var aiStarIcon = "_ax-4";
export var closeButton = "_ax-6";
export var dismissButton = "_ax-3";
export var editImageWithAiContainer = "_ax-8";
export var imageUploadWrapper = "_ax-7";
export var misspelledWord = "_ax-5";
export var spellCheckContainer = "_ax-2";
export var spin = "_ax-1";
export var spinning = "_ax-0";